import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=6f6223b9&scoped=true&"
import script from "./FacebookIcon.vue?vue&type=script&lang=js&"
export * from "./FacebookIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6223b9",
  null
  
)

export default component.exports